import { createContext } from 'react';

export interface ContextInterface {
  messages: Array<any>,
  setMessage: (message: string, type: string) => void,
}

export const Context = createContext<ContextInterface>({
  messages: [],
  setMessage: () => {},
});

export const ContextProvider = Context.Provider;
export const ContextConsumer = Context.Consumer;
